import React from 'react';
import { Panel, Column, Heading, Message } from '../base/Elements';
import { Parallax } from '../fragments/Images';

export const Window = ({heading, message, picture, children}) => (
  <Panel>
    <Column picture>
      {heading && <Heading title={heading[0]} subtitle={heading[1]} />}

      <Picture>
        {typeof picture === 'string' ?
         <Parallax src={picture} /> : picture()}
      </Picture>
    </Column>

    <Column>
      {message && <Message title={message[0]} text={message[1]} />}

      {children}
    </Column>
  </Panel>
)

export const Picture = ({children}) =>
  (<div className="auth__pic">{children}</div>)
